import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const OptumInitialIcon: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g id="Frame 4" clipPath="url(#clip0_2735_36045)">
      <path
        id="Vector"
        d="M121.168 36.8088V9.31393H129.94L129.986 12.5877C131.735 10.0694 134.314 8.90185 137.307 8.90185C141.083 8.90185 143.753 10.6417 145.204 13.366C146.953 10.3899 150.269 8.90185 153.653 8.90185C159.685 8.90185 163 13.4118 163 19.1123V36.8088H154.067V20.463C154.067 17.7845 152.364 16.2048 150.292 16.2048C148.219 16.2048 146.516 17.7845 146.516 20.463V36.8317H137.583V20.463C137.583 17.7845 135.879 16.2048 133.807 16.2048C131.735 16.2048 130.032 17.7845 130.032 20.463V36.8317H121.168V36.8088ZM118.175 26.3466C118.175 33.4206 112.511 37.4269 105.282 37.4269C98.0533 37.4269 92.3897 33.4206 92.3897 26.3466V9.31393H101.368V26.0947C101.368 28.4985 102.957 30.0553 105.282 30.0553C107.608 30.0553 109.196 28.5214 109.196 26.0947V9.31393H118.175V26.3466ZM89.9493 16.4109V9.31393H82.5821V2.28568H73.6493V26.9647C73.6493 33.7869 77.7243 37.2209 84.2857 37.2209C86.1966 37.2209 88.1996 37.0149 89.9493 36.3052V29.2769C88.66 29.689 87.5319 29.8492 86.5419 29.8492C84.1706 29.8492 82.559 28.7733 82.559 26.255V16.4109H89.9493ZM62.3682 23.0728C62.3682 27.0334 59.4904 29.9408 55.9219 29.9408C52.3073 29.9408 49.4295 27.0105 49.4295 23.0728C49.4295 19.181 52.3073 16.2506 55.9219 16.2506C59.4674 16.2506 62.3682 19.181 62.3682 23.0728ZM49.4065 47.4771V33.9472C51.6857 36.0533 54.6787 37.2896 57.9709 37.2896C65.4532 37.2896 71.324 30.971 71.324 23.0728C71.324 15.2204 65.4532 8.92474 57.9709 8.92474C54.5175 8.92474 51.4785 10.2526 49.1533 12.519L49.1072 9.33682H40.4507V47.5H49.4065V47.4771ZM28.2718 18.8604C28.2718 24.4922 24.1047 28.7046 18.8785 28.7046C13.6524 28.7046 9.48531 24.4922 9.48531 18.8604C9.48531 13.2287 13.6524 9.01632 18.8785 9.01632C24.1047 9.01632 28.2718 13.2287 28.2718 18.8604ZM18.8785 0.5C8.31116 0.5 0 8.65003 0 18.8604C0 29.0709 8.31116 37.2209 18.8785 37.2209C29.4459 37.2209 37.7571 29.0709 37.7571 18.8604C37.7571 8.65003 29.4459 0.5 18.8785 0.5Z"
        fill="#FF612B"
      />
    </g>
    <defs>
      <clipPath id="clip0_2735_36045">
        <rect
          width="38"
          height="37"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </Box>
)
export default OptumInitialIcon
